import { render, staticRenderFns } from "./keycloak.vue?vue&type=template&id=58d70bb4&scoped=true"
import script from "./keycloak.vue?vue&type=script&lang=ts"
export * from "./keycloak.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d70bb4",
  null
  
)

export default component.exports